<template>
  <div class="box">
<!--    <img class="lb1" src="../images/lb1.jpg">-->
    <div class="l_nav">
      <ul>
        <li>当前位置：</li>
        <li @click="goIndex"><a href="javascript:;">首页 </a></li>
        <template v-if="params.name">
          <li><span> > </span></li>
          <li @click="goBack"><a href="javascript:;">{{params.name}}</a></li>
        </template>
<!--        <li><span> > </span></li>-->
<!--        <li>{{detailsData.journalisTitle}}</li>-->
      </ul>
    </div>
    <div class="content">
      <div class="title">{{detailsData.journalisTitle}}</div>
      <div class="title_m">
        <span>信息来源：{{detailsData.message}}</span>
        <span>发布日期：{{toDate(detailsData.createTime, 'yyyy-MM-dd')}}</span>
      </div>
      <div class="ql-editor" v-html="text"></div>
    </div>
  </div>
</template>
<script>
import { websiteListQueryId,getTextarea } from "@/api/template";
export default {
  name: "Details",
  components: { },
  data() {
    return {
      detailsData: '',
      params: '',
      text: ''
    };
  },
  created(){
    this.params = JSON.parse(window.sessionStorage.getItem('detailsValue'))
    this.init()
  },
  methods: {
    init(){
      websiteListQueryId(this.params.id).then(res =>{
        this.detailsData = res.data
        this.getTextareaFun(res.data.journalisContent)
      })
    },
    goBack(){
      this.$router.go(-1)
    },
    goIndex(){
      this.$router.push("/template-tenthMobile");
    },
    getTextareaFun(journalisContent){
      let params = {
        "journalisContent":journalisContent
      }
      getTextarea(params).then(res =>{
        this.text = res.data.dataHtml
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.box{
  background: #fff;
  width: 24rem;
  margin: .5rem auto;
}
.lb1{
  display: block;
  width: 23rem;
  margin: 0 auto .5rem;
}
.l_nav{
  width: 23rem;
  margin: 0 auto;
  height: 2rem;
  //background-color: #f7f7f7;
  padding: .5rem;
  ul{
    width: 23rem;
    margin: 0 auto;
    li{
      float: left;
      line-height: 2rem;
      span{
        padding: 0 .5rem;
      }
    }
  }
}
.content{
  width: 22rem;
  min-height: 28rem;
  margin: 0 auto;
  padding: 0 1rem;
  //padding: 20px;
  //background: #fff;
  .title{
    color: #1e3c5a;
    font-size: 1.2rem;
    text-align: center;
    line-height: 2rem;
    font-weight: bold;
  }
  .title_m{
    text-align: center;
    border-bottom: 1px solid #d7d7d7;
    padding-bottom: .5rem;
    //padding: 20px;
    font-size: .5rem;
    span{
      margin-right: 1.5rem;
    }
  }
  .ql-editor{
    padding: .5rem;
    line-height: 1.5rem;
  }
}
.fenge{
  background-color: #D2D2D2;
  height: 1.5rem;
  margin-top: .5rem;
  clear: both;
}
.footer{
  background-color: #3e4753;
  padding: .5rem 0;
  clear: both;
  .footerBox{
    width: 1200px;
    margin: 0 auto;
    color: #d2d2d2;
    font-size: 1rem;
    line-height: 1.5rem;
    span{
      margin-right: 1.5rem;
    }
  }
}
</style>
<style>
.ql-align-center{
  text-align: center!important;
}
</style>
